module.exports = "/_next/static/images/Hero-d1c41fa28efa05eb6b4093c0d57ae5f4.png";